<div class="card rounded-2">
	<div class="card-body bg-gray-200  px-4 py-2">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item">
				<a class="nav-link active" data-bs-toggle="tab" href="#roles_pane_1">Roles</a>
			</li>
		</ul>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="roles_pane_1" role="tabpanel">
				<app-cm-roles-list></app-cm-roles-list>
			</div>
		</div>
	</div>
</div>

<router-outlet></router-outlet>

<app-common-add-role-modal (roleAdded)="onRoleAdded()"></app-common-add-role-modal>
<app-common-update-role-modal (roleUpdated)="onRoleUpdated()"></app-common-update-role-modal>

<script src="/assets/js/custom/apps/user-management/roles/list/add.js"></script>
<script src="/assets/js/custom/apps/user-management/roles/list/update-role.js"></script>